import { healthResponseSchema, type HealthResponse } from '@makemypartner/shared';

const API_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:4000';

export class ApiError extends Error {
  constructor(
    message: string,
    readonly status?: number,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export async function fetchHealth(signal?: AbortSignal): Promise<HealthResponse> {
  let res: Response;
  try {
    res = await fetch(`${API_URL}/health`, { signal });
  } catch {
    throw new ApiError(`Cannot reach the API at ${API_URL}. Is it running?`);
  }

  // A degraded API answers 503 with a valid body — that's information, not a
  // failure, so parse before deciding anything.
  const body: unknown = await res.json().catch(() => null);
  const parsed = healthResponseSchema.safeParse(body);

  if (!parsed.success) {
    throw new ApiError(`API returned an unrecognised health payload.`, res.status);
  }
  return parsed.data;
}

export { API_URL };
